import React from "react";

const IconComponentMap={
  tagIcon:React.lazy(()=>import("@mui/icons-material/LocalOfferRounded")),
  defaultEntityIcon:React.lazy(()=>import("@mui/icons-material/Folder")),
  homeIcon:React.lazy(()=>import("@mui/icons-material/Home")),
  tankIcon:React.lazy(()=>import("@mui/icons-material/Factory")),
  tankSchedulingIcon:React.lazy(()=>import("@mui/icons-material/CalendarMonth")),
  productIcon:React.lazy(()=>import("@mui/icons-material/Inventory2")),
  skuIcon:React.lazy(()=>import("@mui/icons-material/Category")),
  gtinIcon:React.lazy(()=>import("@mui/icons-material/QrCode2")),
  accountIcon:React.lazy(()=>import("@mui/icons-material/AccountBox")),
  userIcon:React.lazy(()=>import("@mui/icons-material/People")),
  dataMgmtIcon:React.lazy(()=>import("@mui/icons-material/Storage")),
  serverMgmtIcon:React.lazy(()=>import("@mui/icons-material/Memory")),
  errorLogsIcon:React.lazy(()=>import("@mui/icons-material/BugReportOutlined")),
  salesOrdersIcon:React.lazy(()=>import("@mui/icons-material/Receipt")),
  storageOrdersIcon:React.lazy(()=>import("@mui/icons-material/LocalShippingOutlined")),
  deliveryPricingIcon:React.lazy(()=>import("@mui/icons-material/PriceChangeOutlined")),
  notificationsIcon:React.lazy(()=>import("@mui/icons-material/Notifications")),
  appRolesIcon:React.lazy(()=>import("@mui/icons-material/AdminPanelSettingsOutlined")),
  appMenuIcon:React.lazy(()=>import("@mui/icons-material/AppsOutlined")),
  alcoholLicenseIcon:React.lazy(()=>import("@mui/icons-material/Liquor")),
  packageTypeIcon:React.lazy(()=>import("@mui/icons-material/AllInbox")),
  manufacturingOrderIcon:React.lazy(()=>import("@mui/icons-material/PrecisionManufacturing")),
  batchIcon:React.lazy(()=>import("@mui/icons-material/Science")),
};

export const getIconComponent=(name)=>IconComponentMap[name]||null;